export default __webpack_public_path__ + "static/media/BelicosoOpen.452307c9.jpg";